import { render, staticRenderFns } from "./BtDisegno.vue?vue&type=template&id=343b185a"
import script from "./BtDisegno.vue?vue&type=script&lang=js"
export * from "./BtDisegno.vue?vue&type=script&lang=js"
import style0 from "./BtDisegno.vue?vue&type=style&index=0&id=343b185a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports